import {
	EnvelopeIcon,
	LinkIcon,
	MapPinIcon,
	PhoneIcon,
} from '@heroicons/react/24/solid';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import isEmpty from 'lodash.isempty';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useModuleStore } from '../../components/moduleStore';

const PHONE_FORMAT = /(\d{3})(\d{3})(\d{4})/;

const PrintReferralDetail = () => {
	const { requestId } = useParams();
	let { serviceRequest = {} } = useModuleStore();
	let isFetched = false;
	({ data: serviceRequest, isFetched } = useQuery({
		queryKey: ['worklist', requestId],
		queryFn: async () => {
			const { data } = await axios.get(`/requests/worklist/${requestId}`);
			return data;
		},
		initialData: serviceRequest,
		enabled: !!requestId,
	}));
	useEffect(() => {
		if (isFetched) {
			window.print();
		}
	}, [isFetched]);

	const { data } = serviceRequest?.external_211_service || {};

	return (
		<div className="print-service-detail">
			<h1>{data?.locations?.[0]?.organization_name}</h1>
			<p>{data?.locations?.[0]?.alternate_name}</p>
			<div className="section">
				<div>
					{data?.physical_address?.map((address) => (
						<div key={address.id}>
							<MapPinIcon
								className="inline-block w-6 h-6 pr-1"
								aria-hidden="true"
							/>
							{address?.address_1} {address?.address_2} {address?.address_3}{' '}
							{address?.address_4} | {address?.city} {address?.state_province}
							{', '}
							{address?.postal_code}
						</div>
					))}
				</div>

				<div>
					{data?.phones?.map((phone) => (
						<div key={phone.id}>
							<a href={`tel:${phone?.number}`} className="link">
								<PhoneIcon
									className="inline-block w-6 h-6 pr-1"
									aria-hidden="true"
								/>
								{phone?.number?.replace(PHONE_FORMAT, '($1) $2-$3')}
							</a>{' '}
							{phone?.type && <span>{phone?.type}</span>}
						</div>
					))}
				</div>
			</div>
			<h2>{data?.name}</h2>
			{/* <p> ALICE FUND </p> */}
			<p>{data?.description}</p>

			<div>
				<div className="section">
					<label> Contact </label>
					{isEmpty(data?.url) && isEmpty(data?.email) && (
						<div>No additional contact links</div>
					)}
					{!isEmpty(data?.url) && (
						<div>
							<a
								href={data?.url}
								rel="noopener noreferrer nofollow"
								target="_blank"
								className="link"
							>
								<LinkIcon
									className="inline-block w-5 h-5 pr-1"
									aria-hidden="true"
								/>
								<span>{data?.url}</span>
							</a>
						</div>
					)}
					{!isEmpty(data?.email) && (
						<div>
							<a
								href={`mailto:${data?.email}`}
								rel="noopener noreferrer nofollow"
								target="_blank"
								className="link"
							>
								<EnvelopeIcon
									className="inline-block w-5 h-5 pr-1"
									aria-hidden="true"
								/>
								<span>{data?.email}</span>
							</a>
						</div>
					)}
				</div>
				{data?.area_served_description && (
					<div className="section">
						<label> Serves People Living In </label>
						<p>{data?.area_served_description}</p>
					</div>
				)}
				{data?.program && (
					<div className="section">
						<label> Program </label>
						<p> {data?.program} </p>
					</div>
				)}
				{data?.eligibility && (
					<div className="section">
						<label> Eligibility </label>
						<p>{data?.eligibility}</p>
					</div>
				)}
				{data?.application_process && (
					<div className="section">
						<label>Application Process</label>
						<p>{data?.application_process}</p>
					</div>
				)}
				{data?.required_document && (
					<div className="section">
						<label> Documents Required </label>
						<p>{data?.required_document}</p>
					</div>
				)}
				{data?.fees && (
					<div className="section">
						<label> Fees </label>
						<p>{data?.fees}</p>
					</div>
				)}
				{data?.payment_accepted && (
					<div className="section">
						<label> Payment Methods </label>
						<p> {data?.payment_accepted} </p>
					</div>
				)}
				{data?.schedule_notes && (
					<div className="section">
						<label> Service Hours </label>
						<p> {data?.schedule_notes}</p>
					</div>
				)}
				{data?.language && (
					<div className="section">
						<label> Language </label>
						<p> {data?.language} </p>
					</div>
				)}
				{data?.locations?.map((location) => (
					<div key={location.id}>
						<div className="section">
							<label>Location</label>
							<p>
								{location?.description}
								<br />
								{location?.transportation}
							</p>
						</div>
						{location?.accessibility_for_disabilities && (
							<div className="section">
								<label> Accessibility </label>
								<p>{location?.accessibility_for_disabilities}</p>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default PrintReferralDetail;
